import { XML_Param5 } from "./XML_Param5";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";

export function XML_DrawLinkPDF(target, x, y, clipRect, drawElement, layer) {
  x = XML_ScaleAndShiftX(clipRect.fLeft, drawElement, layer);
  y = XML_ScaleAndShiftY(clipRect.fBottom, drawElement, layer);

  var width = XML_ScaleAndShiftX(clipRect.fRight, drawElement, layer) - x;
  var height = y - XML_ScaleAndShiftY(clipRect.fTop, drawElement, layer);

  var x2 = XML_ScaleAndShiftX(clipRect.fRight, drawElement, layer);
  var y2 = XML_ScaleAndShiftY(clipRect.fTop, drawElement, layer);

  y = drawElement.ConvertY(y);
  y2 = drawElement.ConvertY(y2);

  //XML_Param5('hyp', target, x, y, width, height, drawElement);
  //XML_Param5('hyp', target, x, y, x2, y2, drawElement);
  XML_Param5(
    "hyp",
    target,
    clipRect.fLeft,
    drawElement.ConvertY(clipRect.fBottom),
    clipRect.fRight,
    drawElement.ConvertY(clipRect.fTop),
    drawElement
  );
}
